import { useEffect, useState } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { formatInputDate, hoursDifference } from "../../../utils/Time";
import { PDFInputFile } from "../../../components/PDFFileHandler";
import { MediaPreviewer } from "../../../components/MediaUploader";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import { FloatingControlComponent } from "../../../components/FormComponent";
import {
  filteredIndex,
  filteredItemInArray,
  findItemBySearch
} from "../../../utils/ManageArray";
import {
  formatDateTime,
  formatFileName,
  formatSplitKey,
  plusStringValue
} from "../../../commons/FormatValue";
import {
  AttachFileIcon,
  DeleteIcon,
  GooglePinIcon,
  PreviewIcon
} from "../../../data/iconImage";
import Table from "../../../components/Table";
import ButtonLink from "../../../components/ButtonLink";
import SearchFilter from "../../../components/SearchFilter";
import CardDisplayComponent from "../../../components/CardDisplayComponent";
import FileUploadsService from "../../../services/fileupload.service";
import InformRepairJobsService from "../../../services/informrepairjob.service";
import InformRepairItemsService from "../../../services/informrepairitem.service";

export default function ShowRequisition() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [Repair, setRepair] = useState({ Job: [], Item: [] });
  const [SearchValue, setSearchValue] = useState([]);
  const [data, setData] = useState({
    RepairJob: null,
    Item: [],
    Media: { Image: [], Video: [] }
  });
  const searchInput = state?.SearchValue || [
    {
      name: "id",
      labelName: "repair_doc_no",
      label: "หมายเลขแจ้งซ่อม",
      filterBy: ["repair_doc_no"]
    }
  ];
  const inputField = {
    Repair: [
      {
        name: "repair_doc_no",
        label: "หมายเลขแจ้งซ่อม",
        type: "text",
        disabled: true
      },
      {
        name: "ref_cus_ticket_no",
        label: "อ้างอิง Ticket (ลูกค้า)",
        type: "text",
        size: "1_5",
        readOnly: true
      },
      {
        name: "ref_cus_ticket_date",
        label: "อ้างอิงวันที่แจ้ง (ลูกค้า)",
        type: "date",
        size: "1_5",
        format: (date) => date && formatInputDate(date, "Local")?.date,
        readOnly: true
      },
      {
        name: "job_type_items.Job_Type_Name",
        label: "ประเภทงาน",
        size: "1_5",
        readOnly: true
      },
      {
        name: "job_type_sub_items.Job_Type_Sub_Name",
        label: "ประเภทงานย่อย",
        size: "1_5",
        readOnly: true
      },
      {
        name: "inform_about_road",
        label: "ช่องทางรับเรื่อง",
        size: "1_5",
        readOnly: true
      },
      {
        name: "repair_date",
        label: "วันที่รับแจ้งซ่อม",
        type: "date",
        size: "1_5",
        format: (value) => value && formatInputDate(value, "Local")?.date,
        readOnly: true
      },
      {
        name: "concern_customer_items.Cus_Code",
        label: "รหัสลูกค้า",
        readOnly: true
      },
      {
        name: "concern_customer_items.Cus_Name",
        label: "ชื่อลูกค้า",
        type: "text",
        disabled: true,
        size: "4_5"
      },
      {
        name: "project_no",
        label: "หมายเลขโครงการ",
        type: "text",
        readOnly: true
      },
      {
        name: "service_call",
        label: "Call No.",
        type: "text",
        readOnly: true,
        size: "1_5"
      },
      {
        name: "concern_customer_items.Cus_Address",
        label: "ที่อยู่",
        type: "text",
        size: 6,
        disabled: true,
        plusString: [
          "Cus_Road",
          "Cus_District",
          "Cus_SubDistrict",
          "Cus_Province",
          "Cus_ZipCode"
        ]
      },
      {
        name: "concern_customer_items.Cus_ContactTel",
        label: "เบอร์โทรผู้ติดต่อ 1",
        type: "text",
        disabled: true
      },
      {
        name: "concern_customer_items.Cus_ContactName",
        label: "ผู้ติดต่อ 1",
        type: "text",
        disabled: true
      },
      {
        name: "sub_cus_items.Cus_Code",
        label: "รหัสสาขา",
        size: null,
        readOnly: true
      },
      {
        name: "sub_cus_items.Cus_NumBranch",
        label: "เลขที่สาขา",
        type: "text",
        size: "1_25",
        disabled: true
      },
      {
        name: "sub_cus_items.Cus_Name",
        label: "ชื่อสาขา",
        type: "text",
        size: 2,
        disabled: true
      },
      {
        name: "sub_cus_items.Cus_ContactTel",
        label: "เบอร์โทรผู้ติดต่อ 2",
        type: "text",
        disabled: true
      },
      {
        name: "sub_cus_items.Cus_ContactName",
        label: "ผู้ติดต่อ 2",
        type: "text",
        disabled: true
      },
      {
        name: "sub_cus_items.Cus_Address",
        label: "ที่อยู่",
        size: 6,
        type: "text",
        disabled: true,
        plusString: [
          "Cus_Road",
          "Cus_District",
          "Cus_SubDistrict",
          "Cus_Province",
          "Cus_ZipCode"
        ]
      },
      {
        name: "inform_email",
        label: "อีเมลที่แจ้ง",
        type: "text",
        readOnly: true
      },
      {
        name: "admin_brand_items",
        label: "ธุรการผู้รับผิดชอบแบรนด์",
        readOnly: true,
        plusString: ["Employee_Name", "Employee_Surname"]
      },
      {
        name: "google_map_link",
        label: "Google Map",
        type: "text",
        size: "8_33"
      },
      {
        name: "GoogleMapButton",
        classNames: { col: "w-auto" },
        type: "button",
        size: "0_67",
        disabled: !data?.RepairJob?.GoogleMap_Link,
        icon: { src: GooglePinIcon, alt: "Google Pin Icon" },
        onClick: () =>
          window.open(
            !data?.RepairJob?.GoogleMap_Link || "https://www.google.com/maps",
            "_blank"
          )
      },
      {
        name: "tech_sub_items",
        label: "ชื่อทีม/หัวหน้าช่าง",
        readOnly: true,
        plusString: ["Employee_Name", "Employee_Surname"]
      },
      {
        name: "inform_att_file",
        label: "ไฟล์แนบ",
        type: "text",
        size: "7_25",
        readOnly: true,
        format: (value) => formatFileName(value)
      },
      {
        name: "PreviewButton",
        type: "button",
        size: "0_67",
        disabled: !data?.RepairJob?.inform_att_file,
        icon: { src: PreviewIcon, alt: "Preview Icon" },
        onClick: () =>
          navigate("preview", {
            state: {
              ...state,
              SearchValue,
              filename: data?.RepairJob?.inform_att_file
            }
          })
      },
      {
        name: "DeleteButton",
        type: "button",
        size: "0_67",
        disabled: true,
        icon: { src: DeleteIcon, alt: "Delete Icon" }
      },
      {
        name: "AttachButton",
        type: "button",
        size: "0_67",
        disabled: true,
        icon: { src: AttachFileIcon, alt: "Attach File Icon" }
      },
      {
        name: "inform_doc_status",
        label: "สถานะใบแจ้งงาน",
        type: "text",
        readOnly: true
      }
    ],
    moreRepair: [
      { name: "condi_work_tex", label: "เงื่อนไขในการทำงาน", size: 12 },
      {
        name: "condi_work_type",
        label: "มี PM/ไม่มี PM",
        format: (v) => `${v !== "" ? (v === "PM" ? "มี PM" : "ไม่มี PM") : ""}`
      },
      { name: "Seq_Pm_No", label: "เลขที่ใบสั่งงาน" },
      {
        name: "iss_job_items",
        label: "ผู้จ่ายงาน (FVC)",
        plusString: ["Employee_Name", "Employee_Surname"]
      },
      {
        name: "approve_items",
        label: "ผู้อนุมัติ",
        plusString: ["Employee_Name", "Employee_Surname"]
      }
    ]
  };
  const columns = [
    { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "110px" },
    { name: "รหัสอุปกรณ์", selector: (row) => row?.repair_items?.Item_Code },
    {
      name: "รายละเอียดอุปกรณ์",
      selector: (row) => row?.repair_items?.Item_Name_TH
    },
    { name: "อาการที่ได้รับแจ้ง", selector: (row) => row?.inform_des },
    {
      name: "จน.ชม.ช่างทำงาน (DT)",
      selector: (row) => row?.dt_mas_items?.DT_Hrs
    },
    {
      name: "วัน/เวลา/ครบกำหนด",
      selector: (row) => row?.date_completed,
      format: ({ dt_mas_items, date_completed }) => {
        if (dt_mas_items) {
          const { DT_Hrs } = dt_mas_items;
          const d = new Date(date_completed);
          const hourDiff = hoursDifference(d, DT_Hrs)?.toISOString();
          const dt = formatInputDate(hourDiff, "ISO").datetime;
          return DT_Hrs ? formatDateTime(dt, "DD/MM/YYYY HH:MM น.") : "";
        }
      }
    }
  ];

  const handleSearchFilter = (search, res) => {
    setSearchValue(search);
    const { repair_job_files, ...RepairJob } =
      findItemBySearch(res || Repair.Job, search) || {};
    const filteredItem = filteredItemInArray(
      Repair.Item,
      "inform_repair_id",
      search?.[0]?.value
    );
    setData((prev) => ({ ...prev, RepairJob, Item: filteredItem }));
    if (repair_job_files?.length > 0) {
      repair_job_files.map(({ file_path, file_type }) => {
        const filename = file_path.split("/")?.[2];
        const handleSetMedia = (prev, file, type) => {
          file.name = filename;
          return { ...prev.Media, [type]: [...prev.Media?.[type], file] };
        };
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: FileUploadsService.getFileUploads(
            "ใบแจ้งซ่อม/Media",
            filename
          ),
          callback: (file) =>
            setData((prev) => ({
              ...prev,
              Media: handleSetMedia(prev, file, file_type)
            }))
        });
      });
    } else {
      setData((prev) => ({
        ...prev,
        Media: { ...prev.Media, Image: [], Video: [] }
      }));
    }
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InformRepairJobsService.getAllInformRepairJobs(),
      callback: (res) => {
        if (state?.SearchValue) handleSearchFilter(state?.SearchValue, res);
        setRepair((prev) => ({ ...prev, Job: res }));
      }
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InformRepairItemsService.getAllInformRepairItems(),
      callback: (res) => setRepair((prev) => ({ ...prev, Item: res }))
    });
  }, []);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: { text: "ค้นหาหมายเลขแจ้งซ่อม", className: "text-center" }
        }}
        body={{
          element: (
            <SearchFilter
              data={Repair.Job}
              inputField={searchInput}
              searchCallback={handleSearchFilter}
            />
          )
        }}
      />

      <CardDisplayComponent
        body={{
          as: Row,
          element: inputField.Repair.map(
            (
              {
                name,
                label,
                type,
                size,
                icon,
                disabled,
                plusString,
                format,
                onClick
              },
              idx
            ) => {
              const value = formatSplitKey(name, ".", data?.RepairJob);
              const result =
                (format && format(value)) ||
                (plusString && plusStringValue(plusString, " ", value)) ||
                value;

              return (
                <Col
                  key={idx}
                  sm={size === null ? null : size || 3}
                  className={idx < inputField.Repair.length - 5 ? "mb-3" : ""}
                >
                  {type === "button" ? (
                    name === "AttachButton" ? (
                      <PDFInputFile
                        button={{
                          icon,
                          disabled,
                          color: "outline-secondary",
                          className: "mt-2 p-2 rounded-circle",
                          style: { width: "45px" }
                        }}
                      />
                    ) : (
                      <Button
                        variant="outline-secondary"
                        className="my-2 px-2 rounded-circle"
                        disabled={disabled}
                        onClick={onClick}
                        style={{ width: "45px" }}
                      >
                        <Image src={icon?.src} alt={icon?.alt} />
                      </Button>
                    )
                  ) : (
                    <FloatingControlComponent
                      readOnly
                      type={type}
                      name={name}
                      label={label}
                      disabled={disabled}
                      placeholder="โปรดระบุ"
                      className={{
                        label: idx < inputField.Repair.length - 5 ? "mb-1" : ""
                      }}
                      value={result}
                    />
                  )}
                </Col>
              );
            }
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายละเอียดอุปกรณ์ที่แจ้งซ่อม" } }}
        body={{
          element: <Table data={data.Item} column={columns} pending={loading} />
        }}
      />

      <CardDisplayComponent
        body={{
          element: (
            <FloatingControlComponent
              readOnly
              type="text"
              name="cus_direct_tex"
              label="คำสั่งเพิ่มเติม (ลูกค้า)"
              placeholder="โปรดระบุ"
              value={formatSplitKey("cus_direct_tex", ".", data?.RepairJob)}
            />
          )
        }}
      />

      <CardDisplayComponent
        body={{
          element: (
            <FloatingControlComponent
              readOnly
              type="text"
              name="cus_data_tex"
              label="ข้อมูลที่ได้รับแจ้ง (ลูกค้า)"
              placeholder="โปรดระบุ"
              value={formatSplitKey("cus_data_tex", ".", data?.RepairJob)}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รูปภาพประกอบ (ลูกค้า)" } }}
        body={{
          as: Row,
          element: (
            <MediaPreviewer
              mediaType="Image"
              loading={loading}
              filePreview={filteredIndex(data.Media.Image, "name")}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "วีดีโอประกอบ (ลูกค้า)" } }}
        body={{
          as: Row,
          element: (
            <MediaPreviewer
              mediaType="Video"
              loading={loading}
              filePreview={filteredIndex(data.Media.Video, "name")}
            />
          )
        }}
      />

      <CardDisplayComponent
        body={{
          as: Row,
          element: inputField.moreRepair.map(
            ({ name, label, format, plusString }, idx) => {
              const value = formatSplitKey(name, ".", data?.RepairJob);
              const result =
                (format && format(value)) ||
                (plusString && plusStringValue(plusString, " ", value)) ||
                value;

              return (
                <Col
                  key={idx}
                  sm={idx === 0 ? 12 : 3}
                  className={idx === 0 ? "mb-3" : ""}
                >
                  <FloatingControlComponent
                    readOnly
                    type="text"
                    name={name}
                    label={label}
                    placeholder="โปรดระบุ"
                    className={{ label: idx === 0 ? "mb-1" : "" }}
                    value={result}
                  />
                </Col>
              );
            }
          )
        }}
      />

      <CardDisplayComponent
        footer={{
          className: "text-center",
          element: (
            <ButtonLink
              linkTo="preview"
              stateData={{ name: "search", type: "print", data }}
              buttonClass="me-4 px-5 py-2 text-dark rounded-pill"
              buttonName="แสดงใบแจ้งซ่อม"
              isDisabled={SearchValue?.length === 0}
            />
          )
        }}
      />
    </>
  );
}
